export default "__VITE_ASSET__Bui3prhk__"